import ReactMarkdown, { type Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'

const components: Components = {
  // An image loads by itself, so one could carry what the agent read off the page to another site. Links need a click.
  img: () => null,
  // Links leave the app: a new tab on the web, the system browser on desktop.
  a: ({ node: _node, href, children, ...rest }) => (
    <a href={href} target="_blank" rel="noreferrer noopener" {...rest}>
      {children}
    </a>
  ),
  // Headings in chat are emphasis, not page structure.
  h1: ({ node: _node, ...rest }) => <p className="md-heading" {...rest} />,
  h2: ({ node: _node, ...rest }) => <p className="md-heading" {...rest} />,
  h3: ({ node: _node, ...rest }) => <p className="md-heading" {...rest} />,
  h4: ({ node: _node, ...rest }) => <p className="md-heading" {...rest} />,
  table: ({ node: _node, ...rest }) => (
    <div className="md-table">
      <table {...rest} />
    </div>
  ),
}

/**
 * Agent text as Markdown (GitHub-flavored: lists, tables, code, links). Safe by construction: raw HTML is not rendered
 * and unsafe URLs are dropped. Re-renders cheaply as text streams in; an unfinished `**` just shows until it closes.
 * `compact` drops the gaps between blocks, for one- to three-line previews that clamp.
 */
export function Markdown({
  children,
  compact = false,
  className,
}: {
  children: string
  compact?: boolean
  className?: string
}) {
  return (
    <div className={['md', compact ? 'md-compact' : '', className].filter(Boolean).join(' ')}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components} skipHtml>
        {children}
      </ReactMarkdown>
    </div>
  )
}
